//public functions
export function idInputMatchesPattern(userInput, identityPattern) {
  const matches = userInput.match(identityPattern);
  if (matches && matches.length && matches.length === 1) {
    if (matches[0] === userInput) {
      return true;
    }
  }
  return false;
}

export function extractIdFromInput(userInput, locationPattern, identityPattern) {
  const matches = locateInputMatches(userInput, locationPattern);
  if (matches && matches.length && matches.length >= 1) {
    return extractIdFromInputMatch(matches[0], identityPattern);
  }
  return '';
}

//support functions
function locateInputMatches(userInput, locationPattern) {
  return userInput.match(locationPattern);
}

function extractIdFromInputMatch(inputMatch, identityPattern) {
  const matches = inputMatch.match(identityPattern);
  if (matches.length === 1) {
    return matches[0];
  }
  return '';
}

//established patterns
export const googleAnalyticsIdentityPattern = /[A-z]{2}[-]\d{5,}[-]\d{1,3}/g;
export const googleAnalyticsLocatePattern = /ga\('create',\s'[A-z]{2}[-]\d{5,}[-]\d{1,3}',\s'auto'\);/g;
export const facebookPixelIdentityPattern = /\d{15,}/g;
export const facebookPixelLocatePattern = /fbq\('init',\s'\d{15,}'\);/g;
export const privyIdentityPattern = /[0-9A-z]{20,}/g;
export const privyLocatePattern = /\|\|\s'[0-9A-z]{20,}';/g;


// WEBPACK FOOTER //
// ./src/app/admin/services/utils/idValidator.js